import { Column, Editing, Item, Lookup, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';

export const SevkiyatKMBilgileri = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const [locations, setLocations] = useState([]);
    const [brand, setBrand] = useState()

    const ref = useRef();
    const mountedRef = useRef(true);

    let skipValidationCheck = false;

    useEffect(() => {
        fetchData();
        fetchLocations();
        getBrand()
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const getBrand = async () => {
        try {
            const response = await api.post("/getAllBrands")
            setBrand(response.data.data || [])
        }
        catch (error) {
            console.error("Error fetching brands:", error);
            toast.error(t("Markalar yüklenirken hata oluştu"));
        }
    }

    const fetchData = async () => {
        try {
            const response = await api.post("shippingKM/getAll");
            if (mountedRef.current) {
                setDataSources(response.data.data || []);
            }
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching shipping KMs:", error);
        }
    };

    const fetchLocations = async () => {
        try {
            const response = await api.post("/shippingLocation/getAll");
            if (mountedRef.current) {
                setLocations(response.data.data || []);
            }
        } catch (error) {
            console.error("Error fetching locations:", error);
        }
    };

    const addModel = async (data, e) => {
        data.create_user_id = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));

        try {
            const response = await api.post("shippingKM/create", data);
            if (response.status === 200) {
                skipValidationCheck = true;
                toast.success(t("Ekleme başarılı"));
                fetchData();
            }
        } catch (error) {
            console.error("Error adding shipping KM:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
        }
    };

    const updateModel = async (e, data) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = { ...data.oldData, ...data.newData, update_user_id: employeeId };
        try {
            const response = await api.post("shippingKM/update", body);
            if (response.status === 200) {
                skipValidationCheck = true;
                toast.success(t("Güncelleme başarılı"));
                fetchData();
            }
        } catch (error) {
            console.error("Error updating shipping KM:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            if (skipValidationCheck) {
                e.isValid = true;
                skipValidationCheck = false;
                return;
            }

            e.isValid = false;
            if (!e.oldData) {
                addModel(e.newData, e);
            } else {
                updateModel(e, e);
            }
        }
    };

    return (
        <>
            <Breadcrumb current={t("Sevkiyat KM Bilgileri")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.data.outbound_km = 0;
                        e.data.return_km = 0;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="row"
                        popup={{
                            title: t("Yeni Sevkiyat KM Bilgisi"),
                            showTitle: true,
                            width: 700,
                            height: "auto",
                        }}
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column dataField="km_code" caption={t("KM Kodu")} selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>
                    <Column dataField="km_name" caption={t("KM Adı")} selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>
                    <Column
                        dataField="from_location_id"
                        caption={t("Çıkış Lokasyonu")}
                        lookup={{
                            dataSource: locations.filter(x => x.is_active === true && x.is_warehouse === true),
                            displayExpr: "group_company_title",
                            valueExpr: "id"
                        }}
                        selectedFilterOperation='contains'
                        alignment='center'
                    >
                        <RequiredRule />
                    </Column>
                    <Column
                        dataField="to_location_id"
                        caption={t("Varış Lokasyonu")}
                        lookup={{
                            dataSource: locations.filter(x => x.is_active === true && x.is_warehouse === false),
                            displayExpr: "group_company_title",
                            valueExpr: "id"
                        }}
                        selectedFilterOperation='contains'
                        alignment='center'
                    >
                        <RequiredRule />
                    </Column>
                    <Column
                        dataField="outbound_km"
                        caption={t("Gidiş KM")}
                        dataType="number"
                        selectedFilterOperation='contains'
                        alignment='center'
                    >
                        <RequiredRule />
                    </Column>
                    <Column
                        dataField="return_km"
                        caption={t("Dönüş KM")}
                        dataType="number"
                        selectedFilterOperation='contains'
                        alignment='center'
                    >
                        <RequiredRule />
                    </Column>
                    <Column dataField="brand_id" caption={t("Marka")} selectedFilterOperation='contains' alignment='center'  >
                        <Lookup dataSource={brand} valueExpr="id" displayExpr="brand_name" />
                    </Column>
                    <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>

                    <Toolbar>
                        <Item name="addRowButton" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                onClick={fetchData}
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd"
                                }}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                            &nbsp;
                            <RxButton
                                className='btn btn-success'
                                style={{
                                    color: "white",
                                    paddingInline: "10px",
                                }}
                                onClick={(e) => ButtonOnExporting(e, ref, "Sevkiyat KM Bilgileri")}>
                                <i className="fa fa-file-excel-o"></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card >
        </>
    );
};